// @flow
import React from "react";
import Icons from "../icons";
import { Row, Col } from "reactstrap";

type Props = $Exact<{
  message: ?string,
}>;

export const InfoSection = (props: Props) => (
  <Row noGutters>
    <Col sm={1}>
      <Icons.QuestionIcon color="navy" className="callback-info-icon" />
    </Col>
    <Col>
      <h6>{props.message}</h6>
    </Col>
  </Row>
);

export default InfoSection;
